module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = 129
// module chunks = 1